// What the golfer sees after Stripe sends them back to
// `/coach/:idOrSlug/purchase/virtual-coaching`. The backend creates the
// request from Stripe's webhook, so the lookup can answer "Transaction not
// found" for a few seconds after a successful payment. The lookup retries a
// bounded number of times and the page never stays pending past the timeout.

export const RETURN_STATE = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  FAILED: 'failed',
  FALLBACK: 'fallback',
}

// Lookup retries: every 2s, 15 times, about 30s in total.
export const LOOKUP_RETRY_DELAY_MS = 2000
export const LOOKUP_MAX_RETRIES = 15

// Hard stop for the pending screen, a backstop for a Stripe.js that never
// loads or a lookup that never settles. After it the page says the payment
// was received.
export const PENDING_TIMEOUT_MS = 45000

const NOT_READY_MESSAGE = /not found|no product found/i

// Only the "webhook has not created it yet" answer and transient network
// failures are worth retrying; any other GraphQL error will not fix itself.
export const isRetryableLookupError = error => {
  if (!error) return false
  if (error.networkError) return true
  return NOT_READY_MESSAGE.test(error.message || '')
}

// `pi_123_secret_abc` -> `pi_123`. Lets the lookup start without waiting for
// Stripe.js to retrieve the payment intent.
export const getPaymentIntentIdFromSecret = clientSecret =>
  typeof clientSecret === 'string' && clientSecret.includes('_secret_')
    ? clientSecret.split('_secret_')[0]
    : null

export const getReturnState = ({
  product,
  purchaseStatus,
  redirectStatus,
  hasClientSecret = true,
  lookupError,
  timedOut,
}) => {
  if (product) return RETURN_STATE.CONFIRMED
  if (
    !hasClientSecret ||
    redirectStatus === 'failed' ||
    purchaseStatus === 'canceled'
  ) {
    return RETURN_STATE.FAILED
  }
  if ((lookupError && purchaseStatus !== 'pending') || timedOut) {
    return RETURN_STATE.FALLBACK
  }
  return RETURN_STATE.PENDING
}
